import React from "react";
import { useNavigate } from "react-router-dom";
import { useForm, Controller } from "react-hook-form";
import { Box, Grid, TextField, Typography } from "@mui/material";
import { useContext, useState } from "react";
import Swal from "sweetalert2";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import styled from "styled-components";
import { Button } from "@mui/base";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import { errorMessages } from "../../../../components/utilities/formValidation";
import classes from "../Home/Home.module.css";
import { postApiData } from "../../../../components/utilities/nodeApiServices";
import { apiList } from "../../../../components/utilities/nodeApiList";
import DataTable from "./tableTab2Home";
import SliderTestimonials from "./HomeSlider/HomeSlider";
import AccountStatement from "../CorporateHome/AccountStatement";
import AccountStatementHome from "./AccountStatementHome";
import Loader from "../../../../components/common/loader";
import LoanTab from "./LoanTab";
import SweetAlertPopup from "../../../../components/common/sweetAlertPopup";
import { useLanguage } from "../../../../context/LanguageContext";
import AutocompleteForm from "../../../../components/common/autuCompleteForm";
import DatePickerForm from "../../../../components/common/datePickerForm";
import { convertDate } from "../../../../components/utilities/convertDate";
import { FiEye, FiEyeOff } from "react-icons/fi";
import { useRef } from "react";
import OwlCarousel from 'react-owl-carousel';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';
import { MdWarningAmber } from 'react-icons/md';
import { IoClose } from 'react-icons/io5';
import AccountSlider from "./AccountSlider";
import QuickTransferModal from "./QuickTransferModal";
import FundsTransferModal from "./FundsTransferModal";
import { numberCommaFormat } from "../../../../components/common/commonArray";


const defaultFormData = {
  email: "",
  password: "",
};

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const InternetDashboard = ({
  name,
  size = 40,
  bg = "#FFDBC2",
  textColor = "#000"
}) => {

  const [valueTable, setValueTable] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValueTable(newValue);
  };

  const {
    control,
    handleSubmit,
    setValue,
    getValues,
    register,
    watch,
    reset,
    formState: { isSubmitting, errors },
  } = useForm({
    defaultValues: defaultFormData,
    mode: "onChange",
  });
  const navigate = useNavigate();
  const { loading, error, isAuthenticated, user, menu } = useSelector(
    (state) => state.auth
  );

  const ColorButton2 = styled(Button)(({ theme }) => ({
    color: "#FFFFFF",

    // backgroundColor: "#F84B67",
    // backgroundColor: "#323232",
    background: "var(--button-color)",
    border: "1px solid #707070",
    borderRadius: "8px",
    paddingLeft: "15px",
    paddingRight: "15px",
    fontSize: '0.8rem',
    width: "8rem",
    height: "35px",
    "&:hover": {
      background: "var(--button-hover-color)",
      color: "white",
    },
    "@media (max-width: 568px)": {
      width: "100%",
      height: "35px",

    },
  }));
  const ColorButton3 = styled(Button)(({ theme }) => ({
    color: "#FFFFFF",

    // backgroundColor: "#F84B67",
    // backgroundColor: "#323232",
    background: "var(--button-color)",
    border: "1px solid #707070",
    borderRadius: "8px",
    paddingLeft: "10px",
    paddingRight: "10px",
    fontSize: '0.8rem',
    width: "12vw",
    height: "35px",
    "&:hover": {
      background: "var(--button-hover-color)",
      color: "white",
    },
    "@media (max-width: 568px)": {
      width: "100%",
      height: "35px",

    },
  }));

  const accountList = user?.accountDetails && user?.accountDetails?.map(item => ({ "code": item.brCode, "value": item.accNo }));
  const { t, language, setLanguage } = useLanguage();
  const isLoanTabEnabled = menu?.[41] == 1;

  const [ToggleState, setToggleState] = useState(true);
  const [accList, setAccList] = useState([]);
  const [miniStatement, setMiniStatement] = useState([]);
  const [isLoading, setIsloading] = useState(false);
  const [shouldRunApi, setshouldRunApi] = useState(false)
  const [accountImage, setAccountImage] = useState(null);
  const [accountStatements, setAccountStatements] = useState(null);
  const [fundTransfers, setFundTransfers] = useState(null);
  const [QRCode, setQRCode] = useState(null);
  const [addImage, setAddImage] = useState(null);
  const [circle, setCircle] = useState(null);
  const [recentTxns, setRecentTxns] = useState([]);   // <── NEW
  const [addsList, setAddsList] = useState([]);
  const bankName = process.env.REACT_APP_FLAVOUR;
  const [depositList, setDepositList] = useState([]);
  const [bannerIdx, setBannerIdx] = useState(0);
  const [bannerIdxCard, setBannerIdxCard] = useState(0);
  const bannerRef = useRef(null);
  const [cardIcon, setCardIcon] = useState(null);
  const [alerts, setAlerts] = useState([]);
  const [accountBalance, setAccountBalance] = useState(null);
  const [accountBalanceFlag, setAccountBalanceFlag] = useState(false);
  const [isloading, setIsLoading] = useState(false);

  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const [openQuick, setOpenQuick] = useState(false);
  const handleOpenQuick = () => setOpenQuick(true);
  const handleCloseQuick = () => setOpenQuick(false);

  const goToSlide = (i) => {
    setBannerIdx(i);

    // smooth‑scroll the track so the i‑th card is left‑aligned
    if (bannerRef.current) {
      const cardWidth = bannerRef.current.firstChild.offsetWidth;
      bannerRef.current.scrollTo({
        left: i * cardWidth,
        behavior: 'smooth',
      });
    }
  };

  const goToSlideCard = (i) => {
    setBannerIdxCard(i);

    // smooth‑scroll the track so the i‑th card is left‑aligned
    if (bannerRef.current) {
      const cardWidth = bannerRef.current.firstChild.offsetWidth;
      bannerRef.current.scrollTo({
        left: i * cardWidth,
        behavior: 'smooth',
      });
    }
  };

  const [hideBal, setHideBal] = useState({});          // { accNo: true | false }
  const [balances, setBalances] = useState({});

  useEffect(() => {
    const track = bannerRef.current;
    if (!track) return;

    // width of one card + the gap (16 px) you set in CSS
    const step = (track.firstChild?.offsetWidth || 0) + 16;

    const onScroll = () =>
      setBannerIdx(Math.round(track.scrollLeft / step));

    track.addEventListener("scroll", onScroll, { passive: true });
    return () => track.removeEventListener("scroll", onScroll);
  }, [addsList]);


  const formatINR = (num) =>
    (Number(num) || 0).toLocaleString("en-IN", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });


  const sliderRef = React.useRef(null);
  const scrollByOne = (dir = 1) => {
    const cardWidth = sliderRef.current?.querySelector(`.${classes.accountCard}`)?.offsetWidth || 0;
    sliderRef.current?.scrollBy({ left: dir * (cardWidth + 16), behavior: "smooth" });
  };

  const radius = size / 2;
  const monthMap = {
    Jan: 0, Feb: 1, Mar: 2, Apr: 3, May: 4, Jun: 5,
    Jul: 6, Aug: 7, Sep: 8, Oct: 9, Nov: 10, Dec: 11,
  };

  const formatDate = (txnDate) => {
    // "30-Apr-2025 13:44:37"  ➜  "Apr 30 2025"
    const [d, mon, y] = txnDate.split(" ")[0].split("-");
    const dateObj = new Date(y, monthMap[mon], d);
    return dateObj.toLocaleDateString("en-US", {
      month: "short",
      day: "numeric",
      year: "numeric",
    });
  };

  const getInitials = (txnType) => txnType?.[0]?.toUpperCase() ?? "?";

  const primarycolor = getComputedStyle(document.documentElement)
    .getPropertyValue("--primary-color")
    .trim();
  const color = getComputedStyle(document.documentElement)
    .getPropertyValue("--light-color")
    .trim();

  // Define the SVG with the dynamic stroke color
  const svgContent = `
      <svg width="40" height="41" viewBox="0 0 40 41" fill="none" xmlns="http://www.w3.org/2000/svg">
<circle cx="20" cy="20.6484" r="20" fill="white"/>
<path d="M11.75 20.6484H28.25" stroke="${primarycolor}" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M20 12.3984V28.8984" stroke="${primarycolor}" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>


          `;
  const AddIconSvg =
    "data:image/svg+xml," + encodeURIComponent(svgContent);


  //Quick Limks



  const fillcolor = getComputedStyle(document.documentElement)
    .getPropertyValue("--light-color")
    .trim();

  const AddAcountSvg = `
       <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
<circle cx="12" cy="12.6484" r="12" fill="${fillcolor}"/>
<path d="M6.92188 12.6484H17.0757" stroke="${primarycolor}" stroke-width="0.970588" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M12 7.57129V17.7251" stroke="${primarycolor}" stroke-width="0.970588" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
`;
  const AddAccountSvgIcon =
    "data:image/svg+xml," + encodeURIComponent(AddAcountSvg);


  // Define the SVG with the dynamic stroke color
  const AccountDetailsSvg = `
       <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_1097_159)">
<path d="M12 21.1484C16.9706 21.1484 21 17.119 21 12.1484C21 7.17787 16.9706 3.14844 12 3.14844C7.02944 3.14844 3 7.17787 3 12.1484C3 17.119 7.02944 21.1484 12 21.1484Z" stroke="${primarycolor}" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M12 15.1484C14.0711 15.1484 15.75 13.4695 15.75 11.3984C15.75 9.32737 14.0711 7.64844 12 7.64844C9.92893 7.64844 8.25 9.32737 8.25 11.3984C8.25 13.4695 9.92893 15.1484 12 15.1484Z" stroke="${primarycolor}" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M5.98145 18.8389C6.54574 17.7274 7.40678 16.7939 8.46914 16.1418C9.5315 15.4897 10.7537 15.1445 12.0002 15.1445C13.2467 15.1445 14.4689 15.4897 15.5312 16.1418C16.5936 16.7939 17.4547 17.7274 18.0189 18.8389" stroke="${primarycolor}" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/>
</g>
<defs>
<clipPath id="clip0_1097_159">
<rect width="24" height="24" fill="white" transform="translate(0 0.148438)"/>
</clipPath>
</defs>
</svg>`;
  const ACCountDetailsSvgIcon =
    "data:image/svg+xml," + encodeURIComponent(AccountDetailsSvg);


  const AccountStatementSvg = `
 <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M9.00195 15.0518H15.0003" stroke="${primarycolor}" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M9.00195 12.0508H15.0003" stroke="${primarycolor}" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M14.999 4.55273H18.748C18.9469 4.55273 19.1376 4.62919 19.2782 4.76529C19.4188 4.90138 19.4978 5.08597 19.4978 5.27844V20.5182C19.4978 20.7106 19.4188 20.8952 19.2782 21.0313C19.1376 21.1674 18.9469 21.2439 18.748 21.2439H5.25175C5.05289 21.2439 4.86218 21.1674 4.72156 21.0313C4.58095 20.8952 4.50195 20.7106 4.50195 20.5182V5.27844C4.50195 5.08597 4.58095 4.90138 4.72156 4.76529C4.86218 4.62919 5.05289 4.55273 5.25175 4.55273H9.00071" stroke="${primarycolor}" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M8.25098 7.55246V6.80267C8.25098 5.80839 8.64596 4.85482 9.34902 4.15176C10.0521 3.44869 11.0057 3.05371 11.9999 3.05371C12.9942 3.05371 13.9478 3.44869 14.6509 4.15176C15.3539 4.85482 15.7489 5.80839 15.7489 6.80267V7.55246H8.25098Z" stroke="${primarycolor}" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
`;
  const ACCountStatementSvgIcon =
    "data:image/svg+xml," + encodeURIComponent(AccountStatementSvg);


  const FundTransferSvg = `
 <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_1097_167)">
<circle cx="11.9999" cy="12.1483" r="5.67606" stroke="${primarycolor}" stroke-width="1.3"/>
<path d="M14.0918 10.8382L13.9044 11.4776H10.3328L10.5202 10.8382H14.0918ZM12.4162 15.1484L10.3989 12.6792L10.3879 12.2162H11.391C11.6519 12.2162 11.8742 12.1794 12.058 12.1059C12.2417 12.0306 12.3822 11.9185 12.4796 11.7697C12.577 11.6191 12.6257 11.4298 12.6257 11.202C12.6257 10.8658 12.5246 10.6022 12.3225 10.4111C12.1204 10.2182 11.8099 10.1217 11.391 10.1217H10.3328L10.5202 9.50439H11.391C11.8393 9.50439 12.2068 9.5788 12.4934 9.72762C12.7818 9.8746 12.995 10.0767 13.1328 10.3339C13.2724 10.5893 13.3422 10.8787 13.3422 11.202C13.3422 11.4941 13.2779 11.7633 13.1493 12.0095C13.0225 12.2538 12.8186 12.4504 12.5375 12.5992C12.2582 12.7481 11.8889 12.8225 11.4296 12.8225H11.4131L13.2761 15.1043V15.1484H12.4162ZM14.0918 9.50439L13.9044 10.1438L11.0934 10.1217L11.2808 9.50439H14.0918Z" fill="#B07246"/>
<path d="M7.87695 0.933594L6.1799 2.63065L7.87695 4.32771" stroke="${primarycolor}" stroke-width="1.3" stroke-linecap="round"/>
<path d="M13.3799 1.98086C13.7389 1.98086 14.0299 2.27187 14.0299 2.63086C14.0299 2.98984 13.7389 3.28086 13.3799 3.28086V1.98086ZM13.3799 2.63086V3.28086H6.17988V2.63086V1.98086H13.3799V2.63086Z" fill="#B07246"/>
<path d="M16.123 19.9688L17.8201 21.6658L16.123 23.3629" stroke="${primarycolor}" stroke-width="1.3" stroke-linecap="round"/>
<path d="M10.6201 21.016C10.2611 21.016 9.97012 21.307 9.97012 21.666C9.97012 22.025 10.2611 22.316 10.6201 22.316V21.016ZM10.6201 21.666V22.316H17.8201V21.666V21.016H10.6201V21.666Z" fill="#B07246"/>
</g>
<defs>
<clipPath id="clip0_1097_167">
<rect width="24" height="24" fill="white" transform="translate(0 0.148438)"/>
</clipPath>
</defs>
</svg>

`;
  const FundTransferSvgIcon =
    "data:image/svg+xml," + encodeURIComponent(FundTransferSvg);


  const GenerateQRSvg = `
<svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M9.75 4.64844H5.25C4.83579 4.64844 4.5 4.98422 4.5 5.39844V9.89844C4.5 10.3127 4.83579 10.6484 5.25 10.6484H9.75C10.1642 10.6484 10.5 10.3127 10.5 9.89844V5.39844C10.5 4.98422 10.1642 4.64844 9.75 4.64844Z" stroke="${primarycolor}" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M9.75 13.6484H5.25C4.83579 13.6484 4.5 13.9842 4.5 14.3984V18.8984C4.5 19.3127 4.83579 19.6484 5.25 19.6484H9.75C10.1642 19.6484 10.5 19.3127 10.5 18.8984V14.3984C10.5 13.9842 10.1642 13.6484 9.75 13.6484Z" stroke="${primarycolor}" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M18.75 4.64844H14.25C13.8358 4.64844 13.5 4.98422 13.5 5.39844V9.89844C13.5 10.3127 13.8358 10.6484 14.25 10.6484H18.75C19.1642 10.6484 19.5 10.3127 19.5 9.89844V5.39844C19.5 4.98422 19.1642 4.64844 18.75 4.64844Z" stroke="${primarycolor}" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M13.5 13.6484V16.6484" stroke="${primarycolor}" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M13.5 19.6484H16.5V13.6484" stroke="${primarycolor}" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M16.5 15.1484H19.5" stroke="${primarycolor}" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M19.5 18.1484V19.6484" stroke="${primarycolor}" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/>
</svg>


`;


  const GenerateQRSvgSvgIcon =
    "data:image/svg+xml," + encodeURIComponent(GenerateQRSvg);

  const NoTransactionSvg = `
<svg width="50" height="50" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
<circle cx="25" cy="25" r="25" fill="${fillcolor}"/>
<path d="M18.0617 11.7943L14.7129 11.7939L16.3367 13.1711L18.0617 11.7943Z" fill="${primarycolor}"/>
<path d="M12.5986 17.9678L16.4012 17.9678V13.5127C16.4012 13.2783 16.3448 13.0426 16.1975 12.8603C15.9188 12.5153 15.4131 12.1016 14.4984 12.1016C13.452 12.1016 12.865 12.6256 12.6642 12.9965C12.61 13.0967 12.5986 13.2121 12.5986 13.326V17.9678Z" fill="white" stroke="${primarycolor}" stroke-width="0.6"/>
<path d="M16.3955 36.9306V17.9672V13.3857C16.3955 12.6765 16.9693 12.1016 17.6785 12.1017C22.3325 12.1022 30.0713 12.1055 31.6641 12.1055C33.4145 12.1055 33.9176 13.2611 33.9524 13.8515V36.9306L32.945 37.7504C32.8241 37.8488 32.65 37.8461 32.5322 37.7441L31.1645 36.56C31.034 36.447 30.8375 36.4575 30.7197 36.5837L29.711 37.6645C29.5825 37.8021 29.3636 37.8002 29.2377 37.6602L28.304 36.6228C28.1764 36.4811 27.9543 36.4811 27.8267 36.6228L26.889 37.6647C26.7645 37.803 26.5488 37.8069 26.4195 37.6731L25.3964 36.6147C25.2637 36.4774 25.0412 36.4856 24.919 36.6323L24.0633 37.6591C23.9451 37.8009 23.7319 37.8141 23.5971 37.6878L22.4219 36.5859C22.2889 36.4613 22.079 36.4722 21.9597 36.6099L21.0496 37.66C20.9276 37.8008 20.7117 37.8085 20.58 37.6767L19.5198 36.6166C19.3827 36.4794 19.1561 36.4943 19.0381 36.6483L18.2361 37.6942C18.1372 37.8233 17.9573 37.858 17.8174 37.7749L16.3955 36.9306Z" fill="white" stroke="${primarycolor}" stroke-width="0.6"/>
<path d="M20.2002 16.7061H29.8313" stroke="${primarycolor}" stroke-width="0.963109" stroke-linecap="round"/>
<path d="M20.2002 25.0537H27.6982" stroke="${primarycolor}" stroke-width="0.963109" stroke-linecap="round"/>
<path d="M20.2002 29.2266H27.263" stroke="${primarycolor}" stroke-width="0.963109" stroke-linecap="round"/>
<path d="M20.2002 33.4004H29.5102" stroke="${primarycolor}" stroke-width="0.963109" stroke-linecap="round"/>
<path d="M20.2002 20.8799H29.8313" stroke="${primarycolor}" stroke-width="0.963109" stroke-linecap="round"/>
<circle cx="33.952" cy="28.038" r="5.45009" fill="${primarycolor}"/>
<path d="M35.079 27.2161V27.3137H35.8875V27.8852H35.0372C34.9861 28.1965 34.8885 28.4451 34.7445 28.631C34.6051 28.8122 34.4053 28.9446 34.1451 29.0282C33.8849 29.1072 33.548 29.1467 33.1345 29.1467V29.5858C33.1345 29.8414 33.1879 30.0435 33.2948 30.1922C33.4063 30.3409 33.5922 30.4152 33.8524 30.4152C34.3263 30.4152 34.5633 30.148 34.5633 29.6137H35.2951C35.2904 30.083 35.1627 30.4384 34.9118 30.6801C34.6655 30.917 34.3077 31.0355 33.8384 31.0355C33.3691 31.0355 33.009 30.9054 32.7581 30.6452C32.5119 30.385 32.3887 30.0203 32.3887 29.551V28.5961C32.9045 28.5961 33.2832 28.5822 33.5248 28.5543C33.7664 28.5218 33.9453 28.4567 34.0615 28.3592C34.1823 28.2616 34.2612 28.1036 34.2984 27.8852H32.096V27.3137H34.3333V27.2161V26.6934H32.096V26.1149H35.8875V26.6934H35.079V27.2161Z" fill="white"/>
</svg>



`;


  const NoTransactionSvgSvgIcon =
    "data:image/svg+xml," + encodeURIComponent(NoTransactionSvg);




  console.log("userfff", user);
  const handleProcess = async (data) => {
    setIsloading(true);
    try {
      const payload = {
        custNo: user?.userId,
        accNo: watch('accountNumber').value,
        accType: "CASA",
        sessionId: user?.sessionId,
        fromDt: convertDate(watch('fromDate'), 4),
        toDt: convertDate(watch('toDate'), 4),

      };

      // handleNavigate(data)
      const response = await postApiData(apiList.PDF_GENERATE, payload);
      // console.log('response',response)
      // const response = await ServerInstance.post(apiList.ACCOUNT_STATEMENT_DOWNLOAD, payload);
      if (response.status) {
        SweetAlertPopup(response.message, "Success", "success")
        // reset()
      } else {
        SweetAlertPopup(response.message, "Error", "error")

      }
      setIsloading(false);
    } catch (err) {
      // console.log(err);
      setIsloading(false);

    }
  };

  /* ------------ helpers ------------- */
  const dismissedKey = (sessionId) => `dismissedAlerts_${sessionId}`;

  const readDismissed = (sessionId) => {
    try {
      return JSON.parse(sessionStorage.getItem(dismissedKey(sessionId)) || "[]");
    } catch {
      return [];
    }
  };

  const writeDismissed = (sessionId, list) => {
    sessionStorage.setItem(dismissedKey(sessionId), JSON.stringify(list));
  };

  console.log("AccNo", accList)

  useEffect(() => {
    const getAccountList = async () => {
      try {
        const payload = { custNo: user?.userId, sessionId: user?.sessionId };
        setIsloading(true);

        const response = await postApiData(apiList.HOME_DASHBOARD_NEW, payload, {
          Authorization: `Bearer ${user?.token}`,
        });

        if (response?.status === true) {
          /* your usual state setup … */
          setAccList(response?.data?.accountlst);
          setMiniStatement(response?.data?.miniStatement);
          setRecentTxns(response.data?.recenTranslist || []);
          setDepositList(response.data?.beneficiary || []);

          try {
            let adds = response.data.adds;
            while (typeof adds === "string") adds = JSON.parse(adds);
            setAddsList(Array.isArray(adds) ? adds : [adds]);
          } catch (err) {
            setAddsList([]);
          }

          /* -------- alerts -------- */
          const now = Date.now();
          const rawMsgs = response?.data?.impMsgs || [];

          // ➊ read list of ids you’ve already dismissed
          const dismissed = readDismissed(user?.sessionId);

          const activeMsgs = rawMsgs
            .filter(
              (m) =>
                m.status === "1" &&
                now >= m.validFrom &&
                now <= m.validTill &&
                !dismissed.includes(String(m.msgId))     // ➋ skip dismissed ones
            )
            .map((m) => ({
              id: String(m.msgId),
              message: m.details || m.name,
            }));

          setAlerts(activeMsgs);
          setIsloading(false);
        } else {
          SweetAlertPopup(response?.message, "Error", "error");
          setIsloading(false);
        }
      } catch (err) {
        setIsloading(false);
      }
    };

    getAccountList();
  }, []); // run once on mount


  const dismiss = (id) => {
    setAlerts((prev) => prev.filter((a) => a.id !== id));

    const dismissed = readDismissed(user?.sessionId);
    if (!dismissed.includes(id)) {
      dismissed.push(id);
      writeDismissed(user?.sessionId, dismissed);   // 📝 remember it
    }
  };


  console.log("addsList", addsList);
  console.log("impmsgs", alerts);
  console.log("accountBalance", accountBalance);
  console.log("accountBalanceFlag", accountBalanceFlag);

  const ref = useRef(null);
  const accNo = watch("accNo");


  const fetchBalance = async (accNo) => {
    try {
      setIsloading(true);

      const payload = {
        accNo,
        custNo: user?.userId,
        sessionId: user?.sessionId,
      };

      const response = await postApiData(apiList.FETCHBAL, payload);

      if (response?.status === true) {
        const balance = response?.data?.accBal ?? "0.00";

        setBalances((prev) => ({
          ...prev,
          [accNo]: { amount: balance, visible: true },
        }));
      } else {
        // if API fails, still record as masked
        setBalances((prev) => ({
          ...prev,
          [accNo]: { amount: "XXXXX", visible: false },
        }));
      }
    } catch (err) {
      console.error("Error fetching balance:", err);
      setBalances((prev) => ({
        ...prev,
        [accNo]: { amount: "XXXXX", visible: false },
      }));
    } finally {
      setIsloading(false);
    }
  };

  const handleHide = (accNo) => {
    setBalances((prev) => ({
      ...prev,
      [accNo]: { ...prev[accNo], visible: false },
    }));
  };

  const options = {
    margin: 10,
    loop: false,
    dots: true,
    mouseDrag: false,
    smartSpeed: 1000,
    autoplay: false,
    nav: false,
    // 👇 default for screens wider than your last break‑point
    items: 2,
    // 👇 tweak how the count changes as the screen shrinks
    responsive: {
      0: { items: 1 },  // phones
      600: { items: 2 },  // small tablets
      1000: { items: 2 },  // anything ≥ 1000 px
    },
  };

  const listClass = `${classes.listQT} ${depositList.length === 0 ? classes.centered : ""
    }`;

  const isFundTransferEnabled = menu?.[21] == 1;
  const isBeneficiaryEnabled = menu?.[11] == 1;


  return (
    <>
      {isLoading ? (<Loader loading={true} />) : (<Loader loading={false} />)}
      <div className={classes.cardsmainpage}>
        <div >
          {alerts.map((a) => (
            <div key={a.id} className={classes.alertBar}>
              <div className={classes.alertContent}>
                <MdWarningAmber size={20} className={classes.leftIcon} />
                <span className={classes.text}>{a.message}</span>
              </div>

              <IoClose
                size={20}
                className={classes.closeBtn}
                onClick={() => dismiss(a.id)}
              />
            </div>
          ))}

        </div>

        <div className={classes.cardDashboard}>
          <div className={classes.leftsidecard}>
            <AccountSlider
              accList={accList}
            />


            <div className={classes.quicktransferlist}>
              <div className={classes.headingQTdashboard}>{t("dashQuickTransfer")}</div>


              <div className={listClass}>
                {depositList.length === 0 ? (

                  <div className={classes.noTxnMsg}>
                    <img
                      className={classes.iconImagesPaddingType1}
                      src={NoTransactionSvgSvgIcon}
                      alt="No transactions"
                    />
                    <div className={classes.NoQuickTransfer}>{t("dashNotransactionsyet")}</div>
                    <div className={classes.NoQuickDesc}>{t("dashNotransactionsyetDesc")}</div>
                  </div>
                ) : (
                  <>

                    {isBeneficiaryEnabled ?
                      <div
                        className={classes.qtAddAccount}
                        onClick={handleOpenQuick}
                        style={{ cursor: "pointer" }}
                      >
                        <div className={classes.circleAdd}>
                          <img
                            className={classes.iconImagesPaddingType1}
                            src={AddIconSvg}
                            alt="Add"
                          />
                        </div>
                        <div className={classes.accDetailsHeadingNew}>{t("dashAddnew")}</div>
                      </div>
                      : <div></div>}



                    {depositList.map((bene, idx) => {
                      const initials = (bene.name || bene.nickname || "")
                        .trim()
                        .split(/\s+/)
                        .slice(0, 2)
                        .map((w) => w[0]?.toUpperCase() || "")
                        .join("");

                      return (
                        <button
                          key={bene.accNo || idx}
                          className={classes.depositCard}
                          onClick={handleOpen}
                          style={{ cursor: "pointer" }}
                        >
                          <div className={classes.circle}>{initials || "?"}</div>
                          <span className={classes.depositCardTitle}>
                            {(bene.name || bene.nickname).split(" ").slice(0, 2).join(" ")}
                          </span>
                        </button>
                      );
                    })}
                  </>
                )}
              </div>
            </div>




            <div className={classes.AccountStatementQuicklinks}>
              <div className={classes.AccountStatement}>

                <div className={classes.ASHeading}>
                  {t("dashAccountstatement")}
                </div>
                {/* <AccountStatementHome accList={accList} /> */}
                <div className={classes.widthtfield}>
                  <div className={classes.frowtext}>{t("accountNumberLabel")}<sup className={classes.required}>*</sup></div>
                  <AutocompleteForm
                    controlerProps={{
                      control: control,
                      name: "accountNumber",
                    }}
                    TextFieldProps={{
                      placeholder: "Select Account Number",
                      onKeyDown: (event) => {
                        // const regex = /^[0-9]*$/;
                        const regex = /^[a-zA-Z0-9]*$/;
                        const isBackspace = event.keyCode === 8;
                        const isValidInput = regex.test(event.key);

                        const currentInputValue = event.target.value;

                        // Maximum length constraint
                        const maxLength = 32; // Set your max length here
                        const isMaxLengthReached = currentInputValue.length >= maxLength;

                        if ((!isValidInput && !isBackspace) || (isMaxLengthReached && !isBackspace)) {
                          event.preventDefault();
                        }
                      },
                    }}
                    rules={{
                      required: "Account Number " + errorMessages.error_autocomplete_message,
                    }}
                    data={accountList}
                    required={true}
                  />

                </div>

                <div className={classes.dateDashboard}>
                  <div className={classes.frowdata11}>
                    <div className={classes.frowtext}>{t("fromDate")}<sup className={classes.required}>*</sup></div>
                    <DatePickerForm
                      controlerProps={{
                        control: control,
                        name: "fromDate",
                      }}
                      TextFieldProps={{
                        //   fullWidth: true,
                      }}
                      DatePickerProps={{
                        // label: "From Date",
                        fullWidth: true,
                        maxDate: new Date()

                      }}
                      required={false}
                    />
                  </div>

                  <div className={classes.frowdata11}>
                    <div className={classes.frowtext}>{t("toDate")}<sup className={classes.required}>*</sup></div>
                    <DatePickerForm
                      controlerProps={{
                        control: control,
                        name: "toDate",
                      }}
                      TextFieldProps={{
                        //   fullWidth: true,
                      }}
                      DatePickerProps={{
                        // label: "From Date",
                        fullWidth: true,
                        minDate: watch("fromDate")?._d,
                        maxDate: new Date()
                      }}
                      required={false}
                    />
                  </div>
                </div>

                <div className={classes.buttonBox}>
                  <ColorButton2 variant="contained" type="button" onClick={handleProcess}>
                    {t("processPDF")}
                  </ColorButton2>

                  <ColorButton2 variant="contained" type="button" onClick={() => navigate('/account/viewstatement', { state: "CASA" })}>
                    {t("viewPDF")}
                  </ColorButton2>
                  {/* <ColorButton2 variant="contained" type="submit">
                      Send to mail
                    </ColorButton2> */}
                </div>

              </div>
              <div className={classes.quicklinks}>
                <div className={classes.qlHeading}>
                  {t("dashQuickLinks")}
                </div>
                <div className={classes.mainQuickLinks}>
                  <div className={classes.firstrowQL}>
                    <div className={classes.quickLinksbox}
                      onClick={() => navigate("/account")}
                      style={{ cursor: "pointer" }}>
                      <div className={classes.accountBoxImage}>
                        <img
                          className={classes.iconImagesPaddingType1}
                          src={ACCountDetailsSvgIcon}
                          alt="Account Details"
                        />
                      </div>
                      <div className={classes.accDetailsHeading}>
                        {t("dashAccountdetails")}
                      </div>
                    </div>
                    <div className={classes.quickLinksbox}
                      onClick={() => navigate("/statements")}
                      style={{ cursor: "pointer" }}
                    >
                      <div className={classes.accountBoxImage}>
                        <img
                          className={classes.iconImagesPaddingType1}
                          src={ACCountStatementSvgIcon}
                          alt="Account statements"
                        />
                      </div>
                      <div className={classes.accDetailsHeading}>
                        {t("dashAccountstatements")}
                      </div>
                    </div>
                  </div>
                  <div className={classes.firstrowQL}>
                    <div className={classes.quickLinksbox}
                      onClick={handleOpen}
                      style={{ cursor: "pointer" }}>
                      <div className={classes.accountBoxImage}>
                        <img
                          className={classes.iconImagesPaddingType1}
                          src={FundTransferSvgIcon}
                          alt="Fund transfer"
                        />
                      </div>
                      <div className={classes.accDetailsHeading}>
                        {t("dashFundtransfer")}
                      </div>
                    </div>
                    {/* <div className={classes.quickLinksbox}>
                      <div className={classes.accountBoxImage}>
                        <img
                          className={classes.iconImagesPaddingType1}
                          src={GenerateQRSvgSvgIcon}
                          alt="Generate QR Code"
                        />
                      </div>
                      <div className={classes.accDetailsHeading}>
                        {t("dashGenerateQRCode")}
                      </div>
                    </div> */}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className={classes.rightsidecard}>
            <div className={classes.rightSideRT}>

              <div className={classes.RTHeading}>
                <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between" }}>
                  <div className={classes.Reecenttransactionheadingdashboard}>
                    {t("dashRecentTransactions")}
                  </div>
                  {/* {recentTxns.length > 0 && (
                    <div className={classes.seeAll}>{t("dashSeeall")}</div>
                  )} */}

                  {recentTxns.length > 0 && (
                    <div
                      className={classes.seeAll}
                      onClick={() => navigate("/fundtransfer/transactionbrowse")} // Update with your target route
                      style={{ cursor: "pointer" }} // Optional: indicates it's clickable
                    >
                      {t("dashSeeall")}
                    </div>
                  )}

                </div>

              </div>
              {recentTxns.length === 0 ? (

                <div className={classes.noTxnMsg}>

                  <div>
                    <img
                      className={classes.iconImagesPaddingType1}
                      src={NoTransactionSvgSvgIcon}
                      alt="NoTransactionSvgSvgIcon"
                    />
                  </div>
                  <div className={classes.NoQuickTransfer}>
                    {t("dashNotransactionsyet")}
                  </div>
                  <div className={classes.NoQuickDesc

                  }>
                    {t("dashNotransactionsyetDesc")}
                  </div>
                  <div>
                    <ColorButton3 variant="contained" type="button" onClick={handleOpenQuick}
                      style={{ cursor: "pointer" }}>
                      {t("dashCreateTransactions")}
                    </ColorButton3>
                  </div>
                </div>

              ) : (

                recentTxns.map((txn, idx) => {
                  const isSuccess = txn.status === "Success";
                  const avatarBg = isSuccess ? "#D1FADF" : "#FEE4E2";
                  const avatarTxt = isSuccess ? "#6CE9A6" : "#FDA29B";
                  const statusCls = isSuccess ? classes.successText : classes.errorText;

                  return (
                    <div key={idx} className={classes.transactionList}>

                      <div className={classes.listNameType}>
                        <div className={classes.imageName}>
                          <div className={classes.depositcardicon}>
                            <svg
                              width={size}
                              height={size}
                              viewBox={`0 0 ${size} ${size}`}
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <circle cx={radius} cy={radius} r={radius} fill={avatarBg} />
                              <text
                                x="50%"
                                y="50%"
                                textAnchor="middle"
                                dominantBaseline="middle"
                                fontFamily="sans-serif"
                                fontSize={size * 0.4}
                                fontWeight="600"
                                fill={avatarTxt}
                              >
                                {getInitials(txn.benName)}
                              </text>
                            </svg>
                          </div>
                        </div>

                        <div className={classes.NameType}>
                          <div className={`${classes.nameTransactionList} ${statusCls}`}>
                            {txn.benName}
                          </div>
                          <div className={classes.TransactionListType}>
                            {txn.txnType}
                          </div>
                        </div>
                      </div>


                      {/* <div className={classes.amountTime}>
                        <div className={`${classes.amountRT} ${statusCls}`}>
                          {txn.amount}
                        </div>
                        <div className={classes.timeRT}>{formatDate(txn.txnDate)}</div>
                      </div> */}
                      <div className={classes.amountTime}>
                        <div className={`${classes.amountRT} ${statusCls}`}>
                          {numberCommaFormat(txn.amount)}
                        </div>
                        <div className={classes.timeRT}>{formatDate(txn.txnDate)}</div>
                      </div>

                    </div>
                  );
                })
              )}
            </div>

          </div>
        </div>

        <div className={classes.lastdashboard}>

          {addsList.length > 0 && (
            <div className={classes.bannerSection}>
              <OwlCarousel
                className="owl-theme"
                items={3}
                loop={true}        // don’t create clones
                margin={10}
                autoplay={true}
                smartSpeed={2000}
                dots
                nav={false}
                mouseDrag={false}
              >
                {addsList.map((ad, i) => (
                  <div
                    key={i}
                    className={classes.bannerCard}
                    onClick={() => ad.redirect && window.open(ad.redirect, "_blank")}
                  >
                    <img src={ad.imgUrl} alt={ad.name} loading="lazy" />
                  </div>
                ))}
              </OwlCarousel>

            </div>
          )}


        </div>

        {isFundTransferEnabled && open ? (
          <FundsTransferModal
            open={open}
            handleClose={handleClose}
          />
        ) : (
          <div></div>
        )}



        {openQuick ? (
          <QuickTransferModal
            open={openQuick}
            handleClose={handleCloseQuick}

          />
        ) : null}
      </div>
    </>
  );
};

export default InternetDashboard;
